export const APP_NAME = 'Nest';

